import { commonResx } from "~/resxDist/commonResx";

export enum ApiErrorTypes {
    UserFriendlyError = "UserFriendlyError",
    ObjectNotFound = "ObjectNotFound",
    UnknownError = "UnknownError",
    ForbiddenError = "ForbiddenError",
    InvalidParameters = "InvalidParameters",
    UnhandledError = "UnhandledError",
    TimeOutError = "TimeOutError",
}

export interface ApiError<T extends string = any> {
    ErrorType: T;
}

export interface UserFriendlyExcBody extends ApiError<ApiErrorTypes.UserFriendlyError> {
    Message?: string;
    /**
     * A human-readable explanation specific to this occurrence of the problem.
     * (c) Microsoft.AspNetCore.Mvc
     */
    detail?: string;
    ErrorPageUrl?: string;
    ErrorKey?: keyof typeof commonResx;
}

export interface ObjectNotFoundErrorBody extends ApiError<ApiErrorTypes.ObjectNotFound> {
    EntityName: string;
    ObjectKey: number;
}

export type ErrorResponse = UserFriendlyExcBody | ObjectNotFoundErrorBody;

type ApiErrorResponseAction<T, ActionType extends string, R = any> = {
    type: ActionType;
    body: T;
    requestData?: R;
};
export type ApiObjectNotFoundAction<ActionType extends string, R = any> = ApiErrorResponseAction<
    ObjectNotFoundErrorBody,
    ActionType,
    R
>;

export type ErrorHandlingOptions = {
    withoutReInit?: boolean;
    callback?: Fn<any>;
    message?: string;
};
